module.exports = __webpack_public_path__ + "img/about_yourself.4aa9d4d0.svg";